var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"card card-custom gutter-b col-lg-13 col-xxl-12 mt-5"},[_vm._v("Chargement ...")]):_c('div',{staticClass:"card card-custom col-lg-13 col-xxl-12 mt-5"},[_c('div',[_c('ClassesManagerTable',{attrs:{"customerId":_vm.customerId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }